
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.12.1
 * Query Engine version: 12e25d8d06f6ea5a0252864dd9a03b1bb51f3022
 */
Prisma.prismaVersion = {
  client: "5.12.1",
  engine: "12e25d8d06f6ea5a0252864dd9a03b1bb51f3022"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UsersScalarFieldEnum = {
  userId: 'userId',
  phoneNumber: 'phoneNumber',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  role: 'role',
  isActive: 'isActive',
  authServiceId: 'authServiceId',
  timezone: 'timezone',
  igHandle: 'igHandle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CustomersScalarFieldEnum = {
  customerId: 'customerId',
  dob: 'dob',
  medicalHistory: 'medicalHistory',
  pronouns: 'pronouns',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  stripeId: 'stripeId',
  streetAddress: 'streetAddress',
  streetAddress2: 'streetAddress2',
  city: 'city',
  state: 'state',
  zip: 'zip'
};

exports.Prisma.EmployeesScalarFieldEnum = {
  employeeId: 'employeeId',
  onschedResourceId: 'onschedResourceId',
  stripeId: 'stripeId',
  calendarAuthUrl: 'calendarAuthUrl',
  calendarEmail: 'calendarEmail',
  calendarAuthorized: 'calendarAuthorized',
  displayName: 'displayName',
  about: 'about',
  profileImage: 'profileImage',
  urlPath: 'urlPath',
  standardDesignMessage: 'standardDesignMessage',
  cancellationPolicyText: 'cancellationPolicyText',
  liabilityWaiver: 'liabilityWaiver',
  minCancellationDays: 'minCancellationDays',
  maxCancellationTimes: 'maxCancellationTimes',
  bookAheadLimitDays: 'bookAheadLimitDays',
  bookInAdvanceMinutes: 'bookInAdvanceMinutes',
  minAppointmentPrice: 'minAppointmentPrice',
  stackDays: 'stackDays',
  stackTimes: 'stackTimes',
  longerAppointmentsPlacement: 'longerAppointmentsPlacement',
  partnerCode: 'partnerCode',
  isSelfService: 'isSelfService',
  reschedulePolicy: 'reschedulePolicy',
  referralLink: 'referralLink',
  reviewLink: 'reviewLink',
  tattooAftercareLink: 'tattooAftercareLink',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  firstLoggedInAt: 'firstLoggedInAt',
  connectedStripeAt: 'connectedStripeAt',
  maxApptsPerDay: 'maxApptsPerDay',
  primaryEmployeeToBusinessId: 'primaryEmployeeToBusinessId',
  paymentCustomerId: 'paymentCustomerId'
};

exports.Prisma.AppointmentsScalarFieldEnum = {
  appointmentId: 'appointmentId',
  employeeId: 'employeeId',
  customerId: 'customerId',
  businessId: 'businessId',
  bookerUserId: 'bookerUserId',
  appointmentType: 'appointmentType',
  status: 'status',
  previousStatus: 'previousStatus',
  onschedId: 'onschedId',
  tattooLocation: 'tattooLocation',
  tattooDetails: 'tattooDetails',
  internalNotes: 'internalNotes',
  tattooSize: 'tattooSize',
  tattooColor: 'tattooColor',
  tattooInspiration: 'tattooInspiration',
  prefTattooStyle: 'prefTattooStyle',
  isFirstTattoo: 'isFirstTattoo',
  isNewCustomer: 'isNewCustomer',
  ongoingProject: 'ongoingProject',
  coverUp: 'coverUp',
  surroundingTattoos: 'surroundingTattoos',
  isEphemeral: 'isEphemeral',
  tattooServiceType: 'tattooServiceType',
  refImgsId: 'refImgsId',
  areaImgsId: 'areaImgsId',
  budget: 'budget',
  skinTone: 'skinTone',
  otherNotes: 'otherNotes',
  availability: 'availability',
  rejectionMessage: 'rejectionMessage',
  cancelationMessage: 'cancelationMessage',
  priceType: 'priceType',
  minPrice: 'minPrice',
  maxPrice: 'maxPrice',
  hourlyPrice: 'hourlyPrice',
  tipAmt: 'tipAmt',
  price: 'price',
  appointmentLengthInMinutes: 'appointmentLengthInMinutes',
  appointmentBufferInMinutes: 'appointmentBufferInMinutes',
  depositPrice: 'depositPrice',
  depositPaymentMethod: 'depositPaymentMethod',
  depositPaidOn: 'depositPaidOn',
  reschedulePrice: 'reschedulePrice',
  rescheduledByCust: 'rescheduledByCust',
  rescheduledByEmployee: 'rescheduledByEmployee',
  customDesignMessage: 'customDesignMessage',
  timezone: 'timezone',
  tripCity: 'tripCity',
  businessTripId: 'businessTripId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  liabilityWaivedOn: 'liabilityWaivedOn',
  deletedAt: 'deletedAt',
  archivedAt: 'archivedAt',
  startDateTime: 'startDateTime',
  endDateTime: 'endDateTime',
  acceptedOn: 'acceptedOn',
  rejectedOn: 'rejectedOn',
  scheduledOn: 'scheduledOn',
  confirmedOn: 'confirmedOn',
  canceledOn: 'canceledOn',
  canceledByUserId: 'canceledByUserId',
  paymentStatus: 'paymentStatus',
  paymentMethod: 'paymentMethod',
  paymentMethods: 'paymentMethods',
  paymentMeta: 'paymentMeta',
  checkoutSessionActive: 'checkoutSessionActive',
  checkoutSessionCompleted: 'checkoutSessionCompleted',
  wasNoShow: 'wasNoShow',
  checkoutCompletedOn: 'checkoutCompletedOn',
  modifiedBy: 'modifiedBy',
  generalRequestId: 'generalRequestId',
  serviceCategory: 'serviceCategory',
  serviceId: 'serviceId',
  piercingLocationId: 'piercingLocationId',
  reschedulingFeesPaid: 'reschedulingFeesPaid',
  includeEmployeeBonus: 'includeEmployeeBonus',
  isDepositRefunded: 'isDepositRefunded',
  isTotalRefunded: 'isTotalRefunded',
  reschedulingFeesRefundAmount: 'reschedulingFeesRefundAmount',
  lastChatMessageAt: 'lastChatMessageAt',
  groupId: 'groupId',
  isTestRequest: 'isTestRequest'
};

exports.Prisma.GeneralRequestsScalarFieldEnum = {
  requestId: 'requestId',
  businessId: 'businessId',
  customerId: 'customerId',
  tattooLocation: 'tattooLocation',
  tattooDetails: 'tattooDetails',
  tattooSize: 'tattooSize',
  tattooColor: 'tattooColor',
  tattooInspiration: 'tattooInspiration',
  prefTattooStyle: 'prefTattooStyle',
  isFirstTattoo: 'isFirstTattoo',
  isNewCustomer: 'isNewCustomer',
  ongoingProject: 'ongoingProject',
  coverUp: 'coverUp',
  surroundingTattoos: 'surroundingTattoos',
  isEphemeral: 'isEphemeral',
  tattooServiceType: 'tattooServiceType',
  refImgsId: 'refImgsId',
  areaImgsId: 'areaImgsId',
  budget: 'budget',
  skinTone: 'skinTone',
  otherNotes: 'otherNotes',
  availability: 'availability',
  rejectionMessage: 'rejectionMessage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  acceptedOn: 'acceptedOn',
  rejectedOn: 'rejectedOn',
  modifiedBy: 'modifiedBy',
  selectedArtists: 'selectedArtists'
};

exports.Prisma.ItemViewsScalarFieldEnum = {
  id: 'id',
  appointmentId: 'appointmentId',
  generalRequestId: 'generalRequestId',
  userId: 'userId',
  createdAt: 'createdAt'
};

exports.Prisma.IntakeQuestionsScalarFieldEnum = {
  questionId: 'questionId',
  step: 'step',
  category: 'category',
  question: 'question',
  description: 'description',
  tooltip: 'tooltip',
  createdAt: 'createdAt',
  required: 'required',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  parentQuestionId: 'parentQuestionId'
};

exports.Prisma.EmployeesToQuestionsScalarFieldEnum = {
  employeeId: 'employeeId',
  questionId: 'questionId',
  customQuestionTitle: 'customQuestionTitle',
  customQuestionSubheader: 'customQuestionSubheader',
  customQuestionPlaceholder: 'customQuestionPlaceholder'
};

exports.Prisma.BusinessesToQuestionsScalarFieldEnum = {
  businessId: 'businessId',
  questionId: 'questionId',
  customQuestionTitle: 'customQuestionTitle',
  customQuestionSubheader: 'customQuestionSubheader',
  customQuestionPlaceholder: 'customQuestionPlaceholder'
};

exports.Prisma.BusinessesScalarFieldEnum = {
  businessId: 'businessId',
  onschedLocationId: 'onschedLocationId',
  stripeId: 'stripeId',
  name: 'name',
  streetAddress: 'streetAddress',
  streetAddress2: 'streetAddress2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  addressDiff: 'addressDiff',
  thumbnailImage: 'thumbnailImage',
  coverImage: 'coverImage',
  urlPath: 'urlPath',
  reviewLink: 'reviewLink',
  tattooAftercareLink: 'tattooAftercareLink',
  allowGeneralRequests: 'allowGeneralRequests',
  disableCreditTipping: 'disableCreditTipping',
  terminalReaderId: 'terminalReaderId',
  stripeLocationId: 'stripeLocationId',
  defaultTattooDeposit: 'defaultTattooDeposit',
  paymentsRate: 'paymentsRate',
  posFeePayer: 'posFeePayer',
  onlineCustomerServiceFeeRate: 'onlineCustomerServiceFeeRate',
  inStoreCustomerServiceFeeRate: 'inStoreCustomerServiceFeeRate',
  stationMax: 'stationMax',
  isActive: 'isActive',
  paymentCustomerId: 'paymentCustomerId',
  connectedStripeAt: 'connectedStripeAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  isSelfService: 'isSelfService',
  isTerminalPurchased: 'isTerminalPurchased',
  type: 'type'
};

exports.Prisma.EmployeesToBusinessesScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  businessId: 'businessId',
  payrollType: 'payrollType',
  payeeForOtherPayroll: 'payeeForOtherPayroll',
  depositToEmployeePercent: 'depositToEmployeePercent',
  paymentToEmployeePercent: 'paymentToEmployeePercent',
  tipToEmployeePercent: 'tipToEmployeePercent',
  bonusCommissionPercent: 'bonusCommissionPercent',
  isBookable: 'isBookable',
  canManageTeam: 'canManageTeam',
  canViewReports: 'canViewReports',
  canManageWaivers: 'canManageWaivers',
  canIssueRefunds: 'canIssueRefunds',
  canManageCampaigns: 'canManageCampaigns',
  canViewAllShopCustomers: 'canViewAllShopCustomers',
  reviewLink: 'reviewLink',
  generalRequestOwner: 'generalRequestOwner',
  addToAllChats: 'addToAllChats',
  color: 'color',
  selectedRoles: 'selectedRoles',
  sortOrder: 'sortOrder'
};

exports.Prisma.TattooChoicesScalarFieldEnum = {
  name: 'name',
  category: 'category',
  value: 'value',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.TripsScalarFieldEnum = {
  tripId: 'tripId',
  employeeId: 'employeeId',
  startDateTime: 'startDateTime',
  endDateTime: 'endDateTime',
  timezone: 'timezone',
  city: 'city',
  state: 'state',
  zip: 'zip',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  streetAddress: 'streetAddress',
  streetAddress2: 'streetAddress2',
  studioName: 'studioName',
  booksOpen: 'booksOpen',
  deletedAt: 'deletedAt'
};

exports.Prisma.TripToAllocationsScalarFieldEnum = {
  tripId: 'tripId',
  allocationId: 'allocationId'
};

exports.Prisma.BusinessTripsScalarFieldEnum = {
  tripId: 'tripId',
  businessId: 'businessId',
  startDateTime: 'startDateTime',
  endDateTime: 'endDateTime',
  timezone: 'timezone',
  city: 'city',
  state: 'state',
  zip: 'zip',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  streetAddress: 'streetAddress',
  streetAddress2: 'streetAddress2',
  studioName: 'studioName',
  booksOpen: 'booksOpen',
  deletedAt: 'deletedAt'
};

exports.Prisma.ImagesScalarFieldEnum = {
  imageRef: 'imageRef',
  employeeId: 'employeeId',
  businessId: 'businessId',
  coverPhoto: 'coverPhoto',
  sortOrder: 'sortOrder'
};

exports.Prisma.FaqsScalarFieldEnum = {
  faqId: 'faqId',
  employeeId: 'employeeId',
  businessId: 'businessId',
  header: 'header',
  text: 'text'
};

exports.Prisma.SmsAlertsScalarFieldEnum = {
  alertId: 'alertId',
  errors: 'errors',
  alerts: 'alerts',
  text: 'text'
};

exports.Prisma.NotificationSettingsScalarFieldEnum = {
  notificationSettingId: 'notificationSettingId',
  userId: 'userId',
  employeeId: 'employeeId',
  businessId: 'businessId',
  notifyOnAllRequests: 'notifyOnAllRequests',
  notifyOnAllAppointments: 'notifyOnAllAppointments',
  emailEnabled: 'emailEnabled',
  smsEnabled: 'smsEnabled',
  preferences: 'preferences'
};

exports.Prisma.ServicesScalarFieldEnum = {
  serviceId: 'serviceId',
  businessId: 'businessId',
  serviceCategory: 'serviceCategory',
  serviceName: 'serviceName',
  serviceDescription: 'serviceDescription',
  defaultPrice: 'defaultPrice',
  defaultDepositPrice: 'defaultDepositPrice',
  defaultDurationInMinutes: 'defaultDurationInMinutes',
  onschedServiceId: 'onschedServiceId',
  minimumAgeInMonths: 'minimumAgeInMonths',
  enableDirectBookings: 'enableDirectBookings',
  aftercareLink: 'aftercareLink',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PiercingLocationsScalarFieldEnum = {
  locationId: 'locationId',
  locationCategory: 'locationCategory',
  locationType: 'locationType'
};

exports.Prisma.EmployeesToServicesScalarFieldEnum = {
  employeeId: 'employeeId',
  serviceId: 'serviceId'
};

exports.Prisma.ReviewLinksScalarFieldEnum = {
  reviewLinkId: 'reviewLinkId',
  appointmentId: 'appointmentId',
  businessId: 'businessId',
  employeeId: 'employeeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  visitedAt: 'visitedAt',
  reviewStatus: 'reviewStatus'
};

exports.Prisma.ReviewsScalarFieldEnum = {
  reviewId: 'reviewId',
  reviewLinkId: 'reviewLinkId',
  rating: 'rating',
  comments: 'comments',
  createdAt: 'createdAt'
};

exports.Prisma.OrdersScalarFieldEnum = {
  orderId: 'orderId',
  businessId: 'businessId',
  customerId: 'customerId',
  employeeId: 'employeeId',
  appointmentId: 'appointmentId',
  createdAt: 'createdAt',
  completedAt: 'completedAt',
  price: 'price',
  customerServiceFee: 'customerServiceFee',
  totalPrice: 'totalPrice',
  paymentMethod: 'paymentMethod',
  paymentMethods: 'paymentMethods',
  status: 'status',
  checkoutSessionActive: 'checkoutSessionActive'
};

exports.Prisma.OrderItemsScalarFieldEnum = {
  orderItemId: 'orderItemId',
  orderId: 'orderId',
  itemId: 'itemId',
  customItemName: 'customItemName',
  customItemPrice: 'customItemPrice',
  quantity: 'quantity',
  taxRate: 'taxRate'
};

exports.Prisma.UserDevicesScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  token: 'token',
  createdAt: 'createdAt'
};

exports.Prisma.EmployeeOnboardingsScalarFieldEnum = {
  id: 'id',
  availability: 'availability',
  bookingLink: 'bookingLink',
  payments: 'payments',
  bookingForm: 'bookingForm',
  clientMessages: 'clientMessages',
  demo: 'demo',
  employeeId: 'employeeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BusinessTaxRatesScalarFieldEnum = {
  id: 'id',
  serviceTaxRate: 'serviceTaxRate',
  productTaxRate: 'productTaxRate',
  businessId: 'businessId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentCustomersScalarFieldEnum = {
  id: 'id',
  stripeCustomerId: 'stripeCustomerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PlansScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  type: 'type',
  price: 'price',
  tier: 'tier',
  active: 'active',
  priceId: 'priceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SubscriptionsScalarFieldEnum = {
  id: 'id',
  paymentCustomerId: 'paymentCustomerId',
  planId: 'planId',
  stripeSubId: 'stripeSubId',
  isFree: 'isFree',
  isCanceled: 'isCanceled',
  trialEndsAt: 'trialEndsAt',
  endsAt: 'endsAt',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SubscriptionInvoicesScalarFieldEnum = {
  id: 'id',
  subscriptionId: 'subscriptionId',
  total: 'total',
  subtotal: 'subtotal',
  stripeInvoiceId: 'stripeInvoiceId',
  status: 'status',
  chargedAt: 'chargedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentCustomerPaymentMethodsScalarFieldEnum = {
  id: 'id',
  paymentCustomerId: 'paymentCustomerId',
  stripePaymentMethodId: 'stripePaymentMethodId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmployeeReferralsScalarFieldEnum = {
  id: 'id',
  usage: 'usage',
  limit: 'limit',
  employeeId: 'employeeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentsScalarFieldEnum = {
  id: 'id',
  method: 'method',
  status: 'status',
  type: 'type',
  types: 'types',
  appointmentId: 'appointmentId',
  orderId: 'orderId',
  customerId: 'customerId',
  stripePaymentIntentId: 'stripePaymentIntentId',
  amount: 'amount',
  discountAmount: 'discountAmount',
  metadata: 'metadata',
  error: 'error',
  receiptEmail: 'receiptEmail',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  completedAt: 'completedAt',
  voidedAt: 'voidedAt',
  processedByUserId: 'processedByUserId',
  groupPaymentsId: 'groupPaymentsId',
  splitPaymentsGroupId: 'splitPaymentsGroupId',
  depositStatus: 'depositStatus',
  isCapturable: 'isCapturable'
};

exports.Prisma.PaymentTransfersScalarFieldEnum = {
  id: 'id',
  stripeTransferId: 'stripeTransferId',
  stripeAccountId: 'stripeAccountId',
  paymentId: 'paymentId',
  amount: 'amount',
  status: 'status',
  entity: 'entity',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WaiversScalarFieldEnum = {
  id: 'id',
  name: 'name',
  status: 'status',
  enabled: 'enabled',
  isDefault: 'isDefault',
  businessId: 'businessId',
  collectAddress: 'collectAddress',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  publishedAt: 'publishedAt'
};

exports.Prisma.StaticWaiverSettingsScalarFieldEnum = {
  id: 'id',
  enabled: 'enabled',
  useDefault: 'useDefault',
  documentLink: 'documentLink',
  attestationText: 'attestationText',
  waiverId: 'waiverId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AcknowledgmentSettingsScalarFieldEnum = {
  id: 'id',
  enabled: 'enabled',
  waiverId: 'waiverId',
  intro: 'intro',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MedicalHistorySettingsScalarFieldEnum = {
  id: 'id',
  enabled: 'enabled',
  waiverId: 'waiverId',
  intro: 'intro',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WaiverEmployeeSettingsScalarFieldEnum = {
  id: 'id',
  enabled: 'enabled',
  waiverId: 'waiverId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WaiverIdentificationSettingsScalarFieldEnum = {
  id: 'id',
  enabled: 'enabled',
  waiverId: 'waiverId',
  text: 'text',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WaiverIdentificationSettingsTypesScalarFieldEnum = {
  identificationSettingsId: 'identificationSettingsId',
  type: 'type',
  enabled: 'enabled',
  text: 'text'
};

exports.Prisma.WaiverRequestIdentificationFilesScalarFieldEnum = {
  id: 'id',
  waiverRequestId: 'waiverRequestId',
  type: 'type',
  url: 'url',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WaiverOptionsScalarFieldEnum = {
  id: 'id',
  text: 'text',
  order: 'order',
  type: 'type',
  acknowledgmentSettingsId: 'acknowledgmentSettingsId',
  medicalHistorySettingsId: 'medicalHistorySettingsId',
  employeeSettingsId: 'employeeSettingsId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WaiverRequestsScalarFieldEnum = {
  id: 'id',
  status: 'status',
  waiverId: 'waiverId',
  customerId: 'customerId',
  appointmentId: 'appointmentId',
  responseData: 'responseData',
  identificationImageLink: 'identificationImageLink',
  signedFileLink: 'signedFileLink',
  previousSignedFileLink: 'previousSignedFileLink',
  submittedByUserId: 'submittedByUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WaiverEventsScalarFieldEnum = {
  id: 'id',
  requestId: 'requestId',
  type: 'type',
  ip: 'ip',
  timestamp: 'timestamp',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ReferralUsesScalarFieldEnum = {
  id: 'id',
  referralId: 'referralId',
  usedByEmployeeId: 'usedByEmployeeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomerInternalNotesScalarFieldEnum = {
  id: 'id',
  note: 'note',
  customerId: 'customerId',
  businessId: 'businessId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomerFilesScalarFieldEnum = {
  id: 'id',
  customerId: 'customerId',
  businessId: 'businessId',
  url: 'url',
  type: 'type',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WaiversToServicesScalarFieldEnum = {
  waiverId: 'waiverId',
  serviceId: 'serviceId',
  type: 'type'
};

exports.Prisma.PaymentRefundsScalarFieldEnum = {
  id: 'id',
  paymentId: 'paymentId',
  stripeRefundId: 'stripeRefundId',
  amount: 'amount',
  reason: 'reason',
  otherReason: 'otherReason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentTransferReversalsScalarFieldEnum = {
  id: 'id',
  transferId: 'transferId',
  stripeReversalId: 'stripeReversalId',
  amount: 'amount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ShopOnboardingStepsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  category: 'category',
  order: 'order',
  isSkippable: 'isSkippable',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ShopOnboardingsScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  stepId: 'stepId',
  status: 'status',
  completedAt: 'completedAt',
  skippedAt: 'skippedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BusinessSettingsScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  cancellationPolicyText: 'cancellationPolicyText',
  minCancellationDays: 'minCancellationDays',
  maxCancellationTimes: 'maxCancellationTimes',
  bookAheadLimitDays: 'bookAheadLimitDays',
  bookInAdvanceMinutes: 'bookInAdvanceMinutes',
  minAppointmentPrice: 'minAppointmentPrice',
  stackDays: 'stackDays',
  stackTimes: 'stackTimes',
  maxApptsPerDay: 'maxApptsPerDay',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MarketingBusinessesScalarFieldEnum = {
  id: 'id',
  sourceBusinessId: 'sourceBusinessId',
  businessId: 'businessId',
  employeeId: 'employeeId',
  monthlySmsCredits: 'monthlySmsCredits',
  monthlyEmailCredits: 'monthlyEmailCredits',
  smsCreditsSurplus: 'smsCreditsSurplus',
  emailCreditsSurplus: 'emailCreditsSurplus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MarketingCampaignsScalarFieldEnum = {
  id: 'id',
  sourceCampaignId: 'sourceCampaignId',
  marketingBusinessId: 'marketingBusinessId',
  name: 'name',
  type: 'type',
  mediums: 'mediums',
  sendType: 'sendType',
  sendAt: 'sendAt',
  includeSegmentId: 'includeSegmentId',
  excludeSegmentId: 'excludeSegmentId',
  prebuiltIncludeSegmentId: 'prebuiltIncludeSegmentId',
  prebuiltExcludeSegmentId: 'prebuiltExcludeSegmentId',
  refundableSmsCredits: 'refundableSmsCredits',
  refundableEmailCredits: 'refundableEmailCredits',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MarketingCustomersScalarFieldEnum = {
  id: 'id',
  sourceCustomerId: 'sourceCustomerId',
  marketingBusinessId: 'marketingBusinessId',
  customerId: 'customerId',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MarketingCampaignSegmentsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  topPercentage: 'topPercentage',
  marketingBusinessId: 'marketingBusinessId',
  condition: 'condition',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MarketingCampaignFiltersScalarFieldEnum = {
  id: 'id',
  category: 'category',
  operator: 'operator',
  value: 'value',
  segmentId: 'segmentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MarketingMediumTemplatesScalarFieldEnum = {
  id: 'id',
  type: 'type',
  marketingBusinessId: 'marketingBusinessId',
  sourceTemplateId: 'sourceTemplateId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MarketingCampaignsToTemplatesScalarFieldEnum = {
  campaignId: 'campaignId',
  templateId: 'templateId',
  createdAt: 'createdAt'
};

exports.Prisma.MarketingSubscribersScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  sourceCustomerId: 'sourceCustomerId',
  phoneNumber: 'phoneNumber',
  status: 'status',
  marketingBusinessId: 'marketingBusinessId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MarketingCustomerListsScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  businessId: 'businessId',
  sourceListId: 'sourceListId',
  marketingBusinessId: 'marketingBusinessId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DiscountsScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  employeeId: 'employeeId',
  name: 'name',
  code: 'code',
  type: 'type',
  amount: 'amount',
  active: 'active',
  payer: 'payer',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.PaymentDiscountsScalarFieldEnum = {
  id: 'id',
  paymentId: 'paymentId',
  discountId: 'discountId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentCustomerAddOnPaymentsScalarFieldEnum = {
  id: 'id',
  method: 'method',
  status: 'status',
  type: 'type',
  stripePaymentIntentId: 'stripePaymentIntentId',
  paymentCustomerId: 'paymentCustomerId',
  marketingCampaignId: 'marketingCampaignId',
  amount: 'amount',
  metadata: 'metadata',
  completedAt: 'completedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ItemsScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  name: 'name',
  category: 'category',
  price: 'price',
  isTaxable: 'isTaxable',
  cost: 'cost',
  commissionType: 'commissionType',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmployeesToItemCommissionsScalarFieldEnum = {
  employeeId: 'employeeId',
  itemId: 'itemId',
  rate: 'rate'
};

exports.Prisma.InactiveEmployeesToBusinessesScalarFieldEnum = {
  employeeId: 'employeeId',
  businessId: 'businessId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UtmAttributionsScalarFieldEnum = {
  id: 'id',
  medium: 'medium',
  source: 'source',
  marketingCampaignId: 'marketingCampaignId',
  externalCampaignId: 'externalCampaignId',
  entity: 'entity',
  entityId: 'entityId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AppointmentGroupsScalarFieldEnum = {
  id: 'id',
  numberOfSessions: 'numberOfSessions',
  schedulingType: 'schedulingType',
  depositPlacement: 'depositPlacement',
  bufferDays: 'bufferDays',
  depositPrice: 'depositPrice',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChatConversationsScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  customerId: 'customerId',
  businessId: 'businessId',
  employeeId: 'employeeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WaiverRequestSessionsScalarFieldEnum = {
  id: 'id',
  waiverRequestId: 'waiverRequestId',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ServicePiercingLocationsScalarFieldEnum = {
  serviceId: 'serviceId',
  piercingLocationId: 'piercingLocationId'
};

exports.Prisma.SplitPaymentsGroupsScalarFieldEnum = {
  id: 'id',
  totalAmountCents: 'totalAmountCents',
  orderId: 'orderId',
  appointmentId: 'appointmentId',
  appointmentPrice: 'appointmentPrice',
  tipAmountCents: 'tipAmountCents',
  discountId: 'discountId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentLineItemsScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  type: 'type',
  orderItemId: 'orderItemId',
  appointmentId: 'appointmentId',
  orderId: 'orderId',
  paymentId: 'paymentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProductEventsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  entityId: 'entityId',
  entityType: 'entityType',
  eventName: 'eventName',
  occuredAt: 'occuredAt',
  properties: 'properties'
};

exports.Prisma.ReferralSourcesScalarFieldEnum = {
  id: 'id',
  type: 'type',
  details: 'details',
  appointmentId: 'appointmentId',
  generalRequestId: 'generalRequestId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.UsersOrderByRelevanceFieldEnum = {
  userId: 'userId',
  phoneNumber: 'phoneNumber',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  authServiceId: 'authServiceId',
  timezone: 'timezone',
  igHandle: 'igHandle'
};

exports.Prisma.CustomersOrderByRelevanceFieldEnum = {
  customerId: 'customerId',
  medicalHistory: 'medicalHistory',
  pronouns: 'pronouns',
  stripeId: 'stripeId',
  streetAddress: 'streetAddress',
  streetAddress2: 'streetAddress2',
  city: 'city',
  state: 'state',
  zip: 'zip'
};

exports.Prisma.EmployeesOrderByRelevanceFieldEnum = {
  employeeId: 'employeeId',
  onschedResourceId: 'onschedResourceId',
  stripeId: 'stripeId',
  calendarAuthUrl: 'calendarAuthUrl',
  calendarEmail: 'calendarEmail',
  displayName: 'displayName',
  about: 'about',
  profileImage: 'profileImage',
  urlPath: 'urlPath',
  standardDesignMessage: 'standardDesignMessage',
  cancellationPolicyText: 'cancellationPolicyText',
  liabilityWaiver: 'liabilityWaiver',
  referralLink: 'referralLink',
  reviewLink: 'reviewLink',
  tattooAftercareLink: 'tattooAftercareLink'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.AppointmentsOrderByRelevanceFieldEnum = {
  appointmentId: 'appointmentId',
  employeeId: 'employeeId',
  customerId: 'customerId',
  businessId: 'businessId',
  bookerUserId: 'bookerUserId',
  onschedId: 'onschedId',
  tattooLocation: 'tattooLocation',
  tattooDetails: 'tattooDetails',
  internalNotes: 'internalNotes',
  tattooSize: 'tattooSize',
  tattooColor: 'tattooColor',
  tattooInspiration: 'tattooInspiration',
  prefTattooStyle: 'prefTattooStyle',
  tattooServiceType: 'tattooServiceType',
  refImgsId: 'refImgsId',
  areaImgsId: 'areaImgsId',
  skinTone: 'skinTone',
  otherNotes: 'otherNotes',
  availability: 'availability',
  rejectionMessage: 'rejectionMessage',
  cancelationMessage: 'cancelationMessage',
  customDesignMessage: 'customDesignMessage',
  timezone: 'timezone',
  tripCity: 'tripCity',
  businessTripId: 'businessTripId',
  canceledByUserId: 'canceledByUserId',
  modifiedBy: 'modifiedBy',
  generalRequestId: 'generalRequestId',
  groupId: 'groupId'
};

exports.Prisma.GeneralRequestsOrderByRelevanceFieldEnum = {
  requestId: 'requestId',
  businessId: 'businessId',
  customerId: 'customerId',
  tattooLocation: 'tattooLocation',
  tattooDetails: 'tattooDetails',
  tattooSize: 'tattooSize',
  tattooColor: 'tattooColor',
  tattooInspiration: 'tattooInspiration',
  prefTattooStyle: 'prefTattooStyle',
  tattooServiceType: 'tattooServiceType',
  refImgsId: 'refImgsId',
  areaImgsId: 'areaImgsId',
  skinTone: 'skinTone',
  otherNotes: 'otherNotes',
  availability: 'availability',
  rejectionMessage: 'rejectionMessage',
  modifiedBy: 'modifiedBy',
  selectedArtists: 'selectedArtists'
};

exports.Prisma.ItemViewsOrderByRelevanceFieldEnum = {
  appointmentId: 'appointmentId',
  generalRequestId: 'generalRequestId',
  userId: 'userId'
};

exports.Prisma.IntakeQuestionsOrderByRelevanceFieldEnum = {
  questionId: 'questionId',
  question: 'question',
  description: 'description',
  tooltip: 'tooltip',
  parentQuestionId: 'parentQuestionId'
};

exports.Prisma.EmployeesToQuestionsOrderByRelevanceFieldEnum = {
  employeeId: 'employeeId',
  questionId: 'questionId',
  customQuestionTitle: 'customQuestionTitle',
  customQuestionSubheader: 'customQuestionSubheader',
  customQuestionPlaceholder: 'customQuestionPlaceholder'
};

exports.Prisma.BusinessesToQuestionsOrderByRelevanceFieldEnum = {
  businessId: 'businessId',
  questionId: 'questionId',
  customQuestionTitle: 'customQuestionTitle',
  customQuestionSubheader: 'customQuestionSubheader',
  customQuestionPlaceholder: 'customQuestionPlaceholder'
};

exports.Prisma.BusinessesOrderByRelevanceFieldEnum = {
  businessId: 'businessId',
  onschedLocationId: 'onschedLocationId',
  stripeId: 'stripeId',
  name: 'name',
  streetAddress: 'streetAddress',
  streetAddress2: 'streetAddress2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  addressDiff: 'addressDiff',
  thumbnailImage: 'thumbnailImage',
  coverImage: 'coverImage',
  urlPath: 'urlPath',
  reviewLink: 'reviewLink',
  tattooAftercareLink: 'tattooAftercareLink',
  terminalReaderId: 'terminalReaderId',
  stripeLocationId: 'stripeLocationId'
};

exports.Prisma.EmployeesToBusinessesOrderByRelevanceFieldEnum = {
  employeeId: 'employeeId',
  businessId: 'businessId',
  reviewLink: 'reviewLink',
  color: 'color',
  selectedRoles: 'selectedRoles'
};

exports.Prisma.TattooChoicesOrderByRelevanceFieldEnum = {
  name: 'name',
  value: 'value'
};

exports.Prisma.TripsOrderByRelevanceFieldEnum = {
  tripId: 'tripId',
  employeeId: 'employeeId',
  timezone: 'timezone',
  city: 'city',
  state: 'state',
  zip: 'zip',
  streetAddress: 'streetAddress',
  streetAddress2: 'streetAddress2',
  studioName: 'studioName'
};

exports.Prisma.TripToAllocationsOrderByRelevanceFieldEnum = {
  tripId: 'tripId',
  allocationId: 'allocationId'
};

exports.Prisma.BusinessTripsOrderByRelevanceFieldEnum = {
  tripId: 'tripId',
  businessId: 'businessId',
  timezone: 'timezone',
  city: 'city',
  state: 'state',
  zip: 'zip',
  streetAddress: 'streetAddress',
  streetAddress2: 'streetAddress2',
  studioName: 'studioName'
};

exports.Prisma.ImagesOrderByRelevanceFieldEnum = {
  imageRef: 'imageRef',
  employeeId: 'employeeId',
  businessId: 'businessId'
};

exports.Prisma.FaqsOrderByRelevanceFieldEnum = {
  faqId: 'faqId',
  employeeId: 'employeeId',
  businessId: 'businessId',
  header: 'header',
  text: 'text'
};

exports.Prisma.SmsAlertsOrderByRelevanceFieldEnum = {
  errors: 'errors',
  alerts: 'alerts',
  text: 'text'
};

exports.Prisma.NotificationSettingsOrderByRelevanceFieldEnum = {
  userId: 'userId',
  employeeId: 'employeeId',
  businessId: 'businessId'
};

exports.Prisma.ServicesOrderByRelevanceFieldEnum = {
  businessId: 'businessId',
  serviceName: 'serviceName',
  serviceDescription: 'serviceDescription',
  onschedServiceId: 'onschedServiceId',
  aftercareLink: 'aftercareLink'
};

exports.Prisma.PiercingLocationsOrderByRelevanceFieldEnum = {
  locationCategory: 'locationCategory',
  locationType: 'locationType'
};

exports.Prisma.EmployeesToServicesOrderByRelevanceFieldEnum = {
  employeeId: 'employeeId'
};

exports.Prisma.ReviewLinksOrderByRelevanceFieldEnum = {
  reviewLinkId: 'reviewLinkId',
  appointmentId: 'appointmentId',
  businessId: 'businessId',
  employeeId: 'employeeId'
};

exports.Prisma.ReviewsOrderByRelevanceFieldEnum = {
  reviewLinkId: 'reviewLinkId',
  comments: 'comments'
};

exports.Prisma.OrdersOrderByRelevanceFieldEnum = {
  orderId: 'orderId',
  businessId: 'businessId',
  customerId: 'customerId',
  employeeId: 'employeeId',
  appointmentId: 'appointmentId'
};

exports.Prisma.OrderItemsOrderByRelevanceFieldEnum = {
  orderId: 'orderId',
  itemId: 'itemId',
  customItemName: 'customItemName'
};

exports.Prisma.UserDevicesOrderByRelevanceFieldEnum = {
  userId: 'userId',
  token: 'token'
};

exports.Prisma.EmployeeOnboardingsOrderByRelevanceFieldEnum = {
  employeeId: 'employeeId'
};

exports.Prisma.BusinessTaxRatesOrderByRelevanceFieldEnum = {
  businessId: 'businessId'
};

exports.Prisma.PaymentCustomersOrderByRelevanceFieldEnum = {
  stripeCustomerId: 'stripeCustomerId'
};

exports.Prisma.PlansOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description',
  priceId: 'priceId'
};

exports.Prisma.SubscriptionsOrderByRelevanceFieldEnum = {
  id: 'id',
  stripeSubId: 'stripeSubId'
};

exports.Prisma.SubscriptionInvoicesOrderByRelevanceFieldEnum = {
  id: 'id',
  subscriptionId: 'subscriptionId',
  stripeInvoiceId: 'stripeInvoiceId'
};

exports.Prisma.PaymentCustomerPaymentMethodsOrderByRelevanceFieldEnum = {
  stripePaymentMethodId: 'stripePaymentMethodId'
};

exports.Prisma.EmployeeReferralsOrderByRelevanceFieldEnum = {
  employeeId: 'employeeId'
};

exports.Prisma.PaymentsOrderByRelevanceFieldEnum = {
  id: 'id',
  appointmentId: 'appointmentId',
  orderId: 'orderId',
  customerId: 'customerId',
  stripePaymentIntentId: 'stripePaymentIntentId',
  error: 'error',
  receiptEmail: 'receiptEmail',
  processedByUserId: 'processedByUserId',
  groupPaymentsId: 'groupPaymentsId',
  splitPaymentsGroupId: 'splitPaymentsGroupId'
};

exports.Prisma.PaymentTransfersOrderByRelevanceFieldEnum = {
  stripeTransferId: 'stripeTransferId',
  stripeAccountId: 'stripeAccountId',
  paymentId: 'paymentId'
};

exports.Prisma.WaiversOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  businessId: 'businessId'
};

exports.Prisma.StaticWaiverSettingsOrderByRelevanceFieldEnum = {
  documentLink: 'documentLink',
  attestationText: 'attestationText',
  waiverId: 'waiverId'
};

exports.Prisma.AcknowledgmentSettingsOrderByRelevanceFieldEnum = {
  waiverId: 'waiverId',
  intro: 'intro'
};

exports.Prisma.MedicalHistorySettingsOrderByRelevanceFieldEnum = {
  waiverId: 'waiverId',
  intro: 'intro'
};

exports.Prisma.WaiverEmployeeSettingsOrderByRelevanceFieldEnum = {
  waiverId: 'waiverId'
};

exports.Prisma.WaiverIdentificationSettingsOrderByRelevanceFieldEnum = {
  waiverId: 'waiverId',
  text: 'text'
};

exports.Prisma.WaiverIdentificationSettingsTypesOrderByRelevanceFieldEnum = {
  text: 'text'
};

exports.Prisma.WaiverRequestIdentificationFilesOrderByRelevanceFieldEnum = {
  waiverRequestId: 'waiverRequestId',
  url: 'url'
};

exports.Prisma.WaiverOptionsOrderByRelevanceFieldEnum = {
  id: 'id',
  text: 'text'
};

exports.Prisma.WaiverRequestsOrderByRelevanceFieldEnum = {
  id: 'id',
  waiverId: 'waiverId',
  customerId: 'customerId',
  appointmentId: 'appointmentId',
  identificationImageLink: 'identificationImageLink',
  signedFileLink: 'signedFileLink',
  previousSignedFileLink: 'previousSignedFileLink',
  submittedByUserId: 'submittedByUserId'
};

exports.Prisma.WaiverEventsOrderByRelevanceFieldEnum = {
  requestId: 'requestId',
  ip: 'ip'
};

exports.Prisma.ReferralUsesOrderByRelevanceFieldEnum = {
  usedByEmployeeId: 'usedByEmployeeId'
};

exports.Prisma.CustomerInternalNotesOrderByRelevanceFieldEnum = {
  note: 'note',
  customerId: 'customerId',
  businessId: 'businessId'
};

exports.Prisma.CustomerFilesOrderByRelevanceFieldEnum = {
  id: 'id',
  customerId: 'customerId',
  businessId: 'businessId',
  url: 'url',
  type: 'type',
  name: 'name'
};

exports.Prisma.WaiversToServicesOrderByRelevanceFieldEnum = {
  waiverId: 'waiverId'
};

exports.Prisma.PaymentRefundsOrderByRelevanceFieldEnum = {
  paymentId: 'paymentId',
  stripeRefundId: 'stripeRefundId',
  otherReason: 'otherReason'
};

exports.Prisma.PaymentTransferReversalsOrderByRelevanceFieldEnum = {
  stripeReversalId: 'stripeReversalId'
};

exports.Prisma.ShopOnboardingStepsOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description'
};

exports.Prisma.ShopOnboardingsOrderByRelevanceFieldEnum = {
  businessId: 'businessId'
};

exports.Prisma.BusinessSettingsOrderByRelevanceFieldEnum = {
  businessId: 'businessId',
  cancellationPolicyText: 'cancellationPolicyText'
};

exports.Prisma.MarketingBusinessesOrderByRelevanceFieldEnum = {
  id: 'id',
  sourceBusinessId: 'sourceBusinessId',
  businessId: 'businessId',
  employeeId: 'employeeId'
};

exports.Prisma.MarketingCampaignsOrderByRelevanceFieldEnum = {
  id: 'id',
  sourceCampaignId: 'sourceCampaignId',
  marketingBusinessId: 'marketingBusinessId',
  name: 'name',
  prebuiltIncludeSegmentId: 'prebuiltIncludeSegmentId',
  prebuiltExcludeSegmentId: 'prebuiltExcludeSegmentId'
};

exports.Prisma.MarketingCustomersOrderByRelevanceFieldEnum = {
  id: 'id',
  sourceCustomerId: 'sourceCustomerId',
  marketingBusinessId: 'marketingBusinessId',
  customerId: 'customerId'
};

exports.Prisma.MarketingCampaignSegmentsOrderByRelevanceFieldEnum = {
  name: 'name',
  marketingBusinessId: 'marketingBusinessId'
};

exports.Prisma.MarketingMediumTemplatesOrderByRelevanceFieldEnum = {
  marketingBusinessId: 'marketingBusinessId',
  sourceTemplateId: 'sourceTemplateId'
};

exports.Prisma.MarketingCampaignsToTemplatesOrderByRelevanceFieldEnum = {
  campaignId: 'campaignId'
};

exports.Prisma.MarketingSubscribersOrderByRelevanceFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  sourceCustomerId: 'sourceCustomerId',
  phoneNumber: 'phoneNumber',
  marketingBusinessId: 'marketingBusinessId'
};

exports.Prisma.MarketingCustomerListsOrderByRelevanceFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  businessId: 'businessId',
  sourceListId: 'sourceListId',
  marketingBusinessId: 'marketingBusinessId'
};

exports.Prisma.DiscountsOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  employeeId: 'employeeId',
  name: 'name',
  code: 'code'
};

exports.Prisma.PaymentDiscountsOrderByRelevanceFieldEnum = {
  paymentId: 'paymentId',
  discountId: 'discountId'
};

exports.Prisma.PaymentCustomerAddOnPaymentsOrderByRelevanceFieldEnum = {
  id: 'id',
  stripePaymentIntentId: 'stripePaymentIntentId',
  marketingCampaignId: 'marketingCampaignId'
};

exports.Prisma.ItemsOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  name: 'name'
};

exports.Prisma.EmployeesToItemCommissionsOrderByRelevanceFieldEnum = {
  employeeId: 'employeeId',
  itemId: 'itemId'
};

exports.Prisma.InactiveEmployeesToBusinessesOrderByRelevanceFieldEnum = {
  employeeId: 'employeeId',
  businessId: 'businessId'
};

exports.Prisma.UtmAttributionsOrderByRelevanceFieldEnum = {
  id: 'id',
  medium: 'medium',
  source: 'source',
  marketingCampaignId: 'marketingCampaignId',
  externalCampaignId: 'externalCampaignId',
  entityId: 'entityId',
  userId: 'userId'
};

exports.Prisma.AppointmentGroupsOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.ChatConversationsOrderByRelevanceFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  customerId: 'customerId',
  businessId: 'businessId',
  employeeId: 'employeeId'
};

exports.Prisma.WaiverRequestSessionsOrderByRelevanceFieldEnum = {
  id: 'id',
  waiverRequestId: 'waiverRequestId'
};

exports.Prisma.SplitPaymentsGroupsOrderByRelevanceFieldEnum = {
  id: 'id',
  orderId: 'orderId',
  appointmentId: 'appointmentId',
  discountId: 'discountId'
};

exports.Prisma.PaymentLineItemsOrderByRelevanceFieldEnum = {
  appointmentId: 'appointmentId',
  orderId: 'orderId',
  paymentId: 'paymentId'
};

exports.Prisma.ProductEventsOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  entityId: 'entityId',
  entityType: 'entityType',
  eventName: 'eventName'
};

exports.Prisma.ReferralSourcesOrderByRelevanceFieldEnum = {
  id: 'id',
  type: 'type',
  details: 'details',
  appointmentId: 'appointmentId',
  generalRequestId: 'generalRequestId'
};
exports.Roles = exports.$Enums.Roles = {
  ADMIN: 'ADMIN',
  CUSTOMER: 'CUSTOMER',
  EMPLOYEE: 'EMPLOYEE',
  SHOP_MANAGER: 'SHOP_MANAGER'
};

exports.SchedulingPlacementOptions = exports.$Enums.SchedulingPlacementOptions = {
  ANY: 'ANY',
  BEGINNING: 'BEGINNING',
  END: 'END'
};

exports.PartnerCodes = exports.$Enums.PartnerCodes = {
  EPHEMERAL: 'EPHEMERAL'
};

exports.ReschedulePolicy = exports.$Enums.ReschedulePolicy = {
  OPEN: 'OPEN',
  REQUESTS: 'REQUESTS',
  CLOSED: 'CLOSED'
};

exports.AppointmentType = exports.$Enums.AppointmentType = {
  WALK_IN: 'WALK_IN',
  NEW_APPOINTMENT: 'NEW_APPOINTMENT',
  FOLLOW_UP_APPOINTMENT: 'FOLLOW_UP_APPOINTMENT',
  CONSULTATION: 'CONSULTATION'
};

exports.AppointmentStatus = exports.$Enums.AppointmentStatus = {
  TEMPORARY: 'TEMPORARY',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  REQUESTED: 'REQUESTED',
  SCHEDULED: 'SCHEDULED',
  CONFIRMED: 'CONFIRMED',
  RESCHEDULED: 'RESCHEDULED',
  CANCELED: 'CANCELED',
  ARCHIVED: 'ARCHIVED'
};

exports.PriceType = exports.$Enums.PriceType = {
  FIXED: 'FIXED',
  HOURLY: 'HOURLY',
  RANGE: 'RANGE'
};

exports.PaymentMethod = exports.$Enums.PaymentMethod = {
  CASH: 'CASH',
  CREDIT: 'CREDIT',
  TERMINAL: 'TERMINAL',
  GIFT_CARD: 'GIFT_CARD'
};

exports.PaymentStatus = exports.$Enums.PaymentStatus = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
  VOIDED: 'VOIDED',
  UNCAPTURED: 'UNCAPTURED'
};

exports.ServiceCategory = exports.$Enums.ServiceCategory = {
  PIERCING: 'PIERCING',
  TATTOO: 'TATTOO',
  PERMANENT_MAKEUP: 'PERMANENT_MAKEUP',
  OTHER: 'OTHER'
};

exports.QuestionCategories = exports.$Enums.QuestionCategories = {
  TATTOO_DETAILS: 'TATTOO_DETAILS',
  INSPIRATION: 'INSPIRATION',
  IMAGES: 'IMAGES',
  GENERAL: 'GENERAL',
  REVIEW: 'REVIEW'
};

exports.FeePayer = exports.$Enums.FeePayer = {
  SPLIT: 'SPLIT',
  BUSINESS: 'BUSINESS',
  EMPLOYEE: 'EMPLOYEE'
};

exports.BusinessPlanType = exports.$Enums.BusinessPlanType = {
  INDEPENDENT: 'INDEPENDENT',
  STUDIO: 'STUDIO'
};

exports.PayrollType = exports.$Enums.PayrollType = {
  COMMISSION: 'COMMISSION',
  RENT: 'RENT',
  WAGE: 'WAGE',
  OTHER: 'OTHER'
};

exports.Payee = exports.$Enums.Payee = {
  BUSINESS: 'BUSINESS',
  EMPLOYEE: 'EMPLOYEE'
};

exports.TattooCategories = exports.$Enums.TattooCategories = {
  TATTOO_COLOR: 'TATTOO_COLOR',
  SKIN_TONE: 'SKIN_TONE',
  PLACEMENT: 'PLACEMENT',
  TATTOO_SIZE: 'TATTOO_SIZE'
};

exports.ReviewStatus = exports.$Enums.ReviewStatus = {
  UNVISITED: 'UNVISITED',
  VISITED: 'VISITED',
  COMPLETED: 'COMPLETED'
};

exports.OrderStatus = exports.$Enums.OrderStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.PlanType = exports.$Enums.PlanType = {
  STUDIO: 'STUDIO',
  ARTIST: 'ARTIST'
};

exports.SubscriptionStatus = exports.$Enums.SubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
  INCOMPLETE: 'INCOMPLETE',
  INCOMPLETE_EXPIRED: 'INCOMPLETE_EXPIRED',
  PAST_DUE: 'PAST_DUE',
  PAUSED: 'PAUSED',
  TRIALING: 'TRIALING',
  UNPAID: 'UNPAID'
};

exports.InvoiceStatus = exports.$Enums.InvoiceStatus = {
  DRAFT: 'DRAFT',
  OPEN: 'OPEN',
  PAID: 'PAID',
  VOID: 'VOID',
  UNCOLLECTIBLE: 'UNCOLLECTIBLE'
};

exports.PaymentType = exports.$Enums.PaymentType = {
  DEPOSIT: 'DEPOSIT',
  RESCHEDULE: 'RESCHEDULE',
  FULL: 'FULL',
  ORDER: 'ORDER',
  IMPORT: 'IMPORT',
  MULTIPLE: 'MULTIPLE'
};

exports.DepositPaymentStatus = exports.$Enums.DepositPaymentStatus = {
  UNUSED: 'UNUSED',
  USED: 'USED',
  FORFEITED: 'FORFEITED',
  REFUNDED: 'REFUNDED',
  VOIDED: 'VOIDED'
};

exports.TransferStatus = exports.$Enums.TransferStatus = {
  INCOMPLETE: 'INCOMPLETE',
  CREATED: 'CREATED',
  REVERSED: 'REVERSED',
  CANCELED: 'CANCELED'
};

exports.TransferEntity = exports.$Enums.TransferEntity = {
  EMPLOYEE: 'EMPLOYEE',
  SHOP: 'SHOP'
};

exports.WaiverStatus = exports.$Enums.WaiverStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED'
};

exports.IdentificationType = exports.$Enums.IdentificationType = {
  ID: 'ID',
  BIRTH_CERTIFICATE: 'BIRTH_CERTIFICATE',
  GUARDIAN_ID: 'GUARDIAN_ID'
};

exports.WaiverOptionType = exports.$Enums.WaiverOptionType = {
  CHECKBOX: 'CHECKBOX',
  TEXT: 'TEXT',
  MULTILINE_TEXT: 'MULTILINE_TEXT',
  SIGNATURE: 'SIGNATURE'
};

exports.WaiverRequestStatus = exports.$Enums.WaiverRequestStatus = {
  QUEUED: 'QUEUED',
  SENT: 'SENT',
  SIGNED: 'SIGNED',
  CANCELED: 'CANCELED'
};

exports.WaiverEventType = exports.$Enums.WaiverEventType = {
  SCHEDULED: 'SCHEDULED',
  SENT: 'SENT',
  VIEWED: 'VIEWED',
  REMINDER: 'REMINDER',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
  REACTIVATED: 'REACTIVATED',
  EMPLOYEE_COMPLETED: 'EMPLOYEE_COMPLETED'
};

exports.PaymentRefundReason = exports.$Enums.PaymentRefundReason = {
  DUPLICATE: 'DUPLICATE',
  REQUESTED_BY_CUSTOMER: 'REQUESTED_BY_CUSTOMER',
  OTHER: 'OTHER'
};

exports.ShopOnboardingID = exports.$Enums.ShopOnboardingID = {
  LOCATION: 'LOCATION',
  STAFF_ONBOARD: 'STAFF_ONBOARD',
  PAYMENTS: 'PAYMENTS',
  BOOKING_LINK: 'BOOKING_LINK',
  WAIVERS: 'WAIVERS',
  SHOP_SETTINGS: 'SHOP_SETTINGS',
  BOOKING_MESSAGES: 'BOOKING_MESSAGES',
  ITEM_LIBRARY: 'ITEM_LIBRARY',
  TERMINAL_READER: 'TERMINAL_READER',
  IMPORT_DATA: 'IMPORT_DATA'
};

exports.ShopOnboardingCategory = exports.$Enums.ShopOnboardingCategory = {
  ACTIVATE: 'ACTIVATE',
  CONFIGURE: 'CONFIGURE'
};

exports.ShopOnboardingStatus = exports.$Enums.ShopOnboardingStatus = {
  INCOMPLETE: 'INCOMPLETE',
  COMPLETE: 'COMPLETE',
  SKIPPED: 'SKIPPED'
};

exports.CampaignType = exports.$Enums.CampaignType = {
  BROADCAST: 'BROADCAST',
  SEQUENCE: 'SEQUENCE'
};

exports.CampaignSendType = exports.$Enums.CampaignSendType = {
  NOW: 'NOW',
  SCHEDULED: 'SCHEDULED'
};

exports.CampaignMedium = exports.$Enums.CampaignMedium = {
  EMAIL: 'EMAIL',
  SMS: 'SMS'
};

exports.MarketingSubscriptionStatus = exports.$Enums.MarketingSubscriptionStatus = {
  SUBSCRIBED: 'SUBSCRIBED',
  UNSUBSCRIBED: 'UNSUBSCRIBED'
};

exports.CampaignSegmentCondition = exports.$Enums.CampaignSegmentCondition = {
  ALL: 'ALL',
  ANY: 'ANY'
};

exports.CampaignFilterCategory = exports.$Enums.CampaignFilterCategory = {
  SPEND: 'SPEND',
  LAST_APPOINTMENT_DATE: 'LAST_APPOINTMENT_DATE',
  APPOINTMENT_CREATED: 'APPOINTMENT_CREATED',
  APPOINTMENT_COUNT: 'APPOINTMENT_COUNT',
  LAST_APPOINTMENT_WITHIN_DAYS: 'LAST_APPOINTMENT_WITHIN_DAYS',
  NEXT_APPOINTMENT_DATE: 'NEXT_APPOINTMENT_DATE',
  EMPLOYEE_RELATION: 'EMPLOYEE_RELATION',
  APPOINTMENT_SERVICE: 'APPOINTMENT_SERVICE'
};

exports.CampaignFilterOperator = exports.$Enums.CampaignFilterOperator = {
  LT: 'LT',
  GT: 'GT'
};

exports.DiscountType = exports.$Enums.DiscountType = {
  PERCENTAGE: 'PERCENTAGE',
  AMOUNT: 'AMOUNT'
};

exports.AddOnPaymentType = exports.$Enums.AddOnPaymentType = {
  MARKETING_CREDITS: 'MARKETING_CREDITS'
};

exports.ItemCategory = exports.$Enums.ItemCategory = {
  AFTERCARE: 'AFTERCARE',
  JEWELRY: 'JEWELRY',
  MERCH: 'MERCH',
  OTHER: 'OTHER'
};

exports.ItemCommissionType = exports.$Enums.ItemCommissionType = {
  REVENUE: 'REVENUE',
  PROFIT: 'PROFIT'
};

exports.UtmEntity = exports.$Enums.UtmEntity = {
  SHOP: 'SHOP',
  EMPLOYEE: 'EMPLOYEE',
  BOOKING: 'BOOKING'
};

exports.AppointmentsSchedulingType = exports.$Enums.AppointmentsSchedulingType = {
  FIRST_SESSION: 'FIRST_SESSION',
  ALL: 'ALL',
  CLIENT_CHOICE: 'CLIENT_CHOICE'
};

exports.AppointmentDepositPlacement = exports.$Enums.AppointmentDepositPlacement = {
  FIRST: 'FIRST',
  LAST: 'LAST'
};

exports.PaymentLineItemType = exports.$Enums.PaymentLineItemType = {
  SERVICE: 'SERVICE',
  SERVICE_TAX: 'SERVICE_TAX',
  RETAIL_ITEM: 'RETAIL_ITEM',
  RETAIL_ITEM_TAX: 'RETAIL_ITEM_TAX',
  FEE: 'FEE',
  TIP: 'TIP',
  SERVICE_DISCOUNT: 'SERVICE_DISCOUNT',
  RETAIL_DISCOUNT: 'RETAIL_DISCOUNT'
};

exports.Prisma.ModelName = {
  Users: 'Users',
  Customers: 'Customers',
  Employees: 'Employees',
  Appointments: 'Appointments',
  GeneralRequests: 'GeneralRequests',
  ItemViews: 'ItemViews',
  IntakeQuestions: 'IntakeQuestions',
  EmployeesToQuestions: 'EmployeesToQuestions',
  BusinessesToQuestions: 'BusinessesToQuestions',
  Businesses: 'Businesses',
  EmployeesToBusinesses: 'EmployeesToBusinesses',
  TattooChoices: 'TattooChoices',
  Trips: 'Trips',
  TripToAllocations: 'TripToAllocations',
  BusinessTrips: 'BusinessTrips',
  Images: 'Images',
  Faqs: 'Faqs',
  SmsAlerts: 'SmsAlerts',
  NotificationSettings: 'NotificationSettings',
  Services: 'Services',
  PiercingLocations: 'PiercingLocations',
  EmployeesToServices: 'EmployeesToServices',
  ReviewLinks: 'ReviewLinks',
  Reviews: 'Reviews',
  Orders: 'Orders',
  OrderItems: 'OrderItems',
  UserDevices: 'UserDevices',
  EmployeeOnboardings: 'EmployeeOnboardings',
  BusinessTaxRates: 'BusinessTaxRates',
  PaymentCustomers: 'PaymentCustomers',
  Plans: 'Plans',
  Subscriptions: 'Subscriptions',
  SubscriptionInvoices: 'SubscriptionInvoices',
  PaymentCustomerPaymentMethods: 'PaymentCustomerPaymentMethods',
  EmployeeReferrals: 'EmployeeReferrals',
  Payments: 'Payments',
  PaymentTransfers: 'PaymentTransfers',
  Waivers: 'Waivers',
  StaticWaiverSettings: 'StaticWaiverSettings',
  AcknowledgmentSettings: 'AcknowledgmentSettings',
  MedicalHistorySettings: 'MedicalHistorySettings',
  WaiverEmployeeSettings: 'WaiverEmployeeSettings',
  WaiverIdentificationSettings: 'WaiverIdentificationSettings',
  WaiverIdentificationSettingsTypes: 'WaiverIdentificationSettingsTypes',
  WaiverRequestIdentificationFiles: 'WaiverRequestIdentificationFiles',
  WaiverOptions: 'WaiverOptions',
  WaiverRequests: 'WaiverRequests',
  WaiverEvents: 'WaiverEvents',
  ReferralUses: 'ReferralUses',
  CustomerInternalNotes: 'CustomerInternalNotes',
  CustomerFiles: 'CustomerFiles',
  WaiversToServices: 'WaiversToServices',
  PaymentRefunds: 'PaymentRefunds',
  PaymentTransferReversals: 'PaymentTransferReversals',
  ShopOnboardingSteps: 'ShopOnboardingSteps',
  ShopOnboardings: 'ShopOnboardings',
  BusinessSettings: 'BusinessSettings',
  MarketingBusinesses: 'MarketingBusinesses',
  MarketingCampaigns: 'MarketingCampaigns',
  MarketingCustomers: 'MarketingCustomers',
  MarketingCampaignSegments: 'MarketingCampaignSegments',
  MarketingCampaignFilters: 'MarketingCampaignFilters',
  MarketingMediumTemplates: 'MarketingMediumTemplates',
  MarketingCampaignsToTemplates: 'MarketingCampaignsToTemplates',
  MarketingSubscribers: 'MarketingSubscribers',
  MarketingCustomerLists: 'MarketingCustomerLists',
  Discounts: 'Discounts',
  PaymentDiscounts: 'PaymentDiscounts',
  PaymentCustomerAddOnPayments: 'PaymentCustomerAddOnPayments',
  Items: 'Items',
  EmployeesToItemCommissions: 'EmployeesToItemCommissions',
  InactiveEmployeesToBusinesses: 'InactiveEmployeesToBusinesses',
  UtmAttributions: 'UtmAttributions',
  AppointmentGroups: 'AppointmentGroups',
  ChatConversations: 'ChatConversations',
  WaiverRequestSessions: 'WaiverRequestSessions',
  ServicePiercingLocations: 'ServicePiercingLocations',
  SplitPaymentsGroups: 'SplitPaymentsGroups',
  PaymentLineItems: 'PaymentLineItems',
  ProductEvents: 'ProductEvents',
  ReferralSources: 'ReferralSources'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
